export const beneficiarySelectionTemplate = `<div class="d-flex">
    <div class="mr-2">{{{ svgIcon 'user-icon-beneficiary' '28px' '28px' }}}</div>
    <div><p class="m-0">{{ name }}</p></div>
</div>
`;

export const beneficiarySelectionHorizontalTemplate = `
<div class="surface-color p-3 w-100">
    <div class="flex items-center justify-content-between border-b border-r-(--color-border-color) pb-3">
    <div class="flex items-center gap-1">
        {{{ currencyToFlag currencyCode '24px' }}}
        <p class="body2 m-0">{{ name }}</p>
    </div>
    <div class="flex-1 text-right">
    {{{ svgIcon 'chevron-right' '24' }}}
    </div>
    </div>
    <div class="flex pt-3">
    {{#if (neq destinationIdentifier.accountNumber '')}}
    <div class="flex-1 overflow-hidden">
        <div class="text-label textOnSurfaceMuted">A/c No.</div>
        <div class="text-value text-overflow-ellipsis">{{ destinationIdentifier.accountNumber }}</div>
    </div>
    {{/if}}
    {{#if (neq destinationIdentifier.iban '')}}
    <div class="flex-1 overflow-hidden">
        <div class="text-label textOnSurfaceMuted">IBAN</div>
        <div class="text-value text-overflow-ellipsis">{{ destinationIdentifier.iban }}</div>
    </div>
    {{/if}}
    {{#if (neq destinationIdentifier.aba '')}}
    <div class="flex-1 overflow-hidden">
        <div class="text-label textOnSurfaceMuted">Routing Code</div>
        <div class="text-value text-overflow-ellipsis">{{ destinationIdentifier.aba }}</div>
    </div>
    {{/if}}
    {{#if (neq destinationIdentifier.sortCode '')}}
    <div class="flex-1 overflow-hidden">
        <div class="text-label textOnSurfaceMuted">Sort Code</div>
        <div class="text-value text-overflow-ellipsis">{{ destinationIdentifier.sortCode }}</div>
    </div>
    {{/if}}
    </div>
</div>
`;
